import React from "react";

import Header from '../img/header.png'
class Template extends React.Component {
  constructor() {
    super();
    this.state = {
        shopifyOrderNumber:'',
        shipingAddress:'',
        lineItems:[],
        currency:'',
        poNumber:'',
        unitPrice:'',
        
        totalPrice:'',
        totalTax:'',
        totalDiscount:'',
        subTotal:'',
        billingInformation:'',
        date:'',
        lineItemsVendor:[0],
    
        // vendor data 
        shippingTerms:'',
        paymentTerms:'',
        shippingMethod:'',
        vendorNames:'',
        vendors:[]

    };
  }

componentDidMount= ()=>{
console.log(window.myObj)
  const data= window.myObj.result2
  console.log("data==" ,data)

  let shippingMethod=window.myObj.shippingMethod;
  let vendorName=window.myObj.selectedVendorName;
  let paymentTerm=window.myObj.paymentTerm;
  let shippingTerm=window.myObj.shippingTerms;


  this.setState({ shopifyOrderNumber: data.name })
  this.setState({shipingAddress:data.shipping_address.address1+" " +data.shipping_address.address2+" "+data.shipping_address.city + " \n"+data.shipping_address.country+" "+data.shipping_address.country_code})
  
 // this.setState({lineItems:Array.from(data.line_items)})

 this.setState({lineItems:data.line_items})
  this.setState({currency:data.currency})
  this.setState({poNumber:data.tags})
  this.setState({unitPrice:data.subtotal_price})
  //this.setState({paymentTerm:data.payment_terms})
  this.setState({totalPrice:data.total_price})
  this.setState({totalTax:data.total_tax})
  this.setState({totalDiscount:data.total_discounts})
  this.setState({subTotal:data.subtotal_price})
  this.setState({ billingInformation: data.billing_address.first_name + " " +  data.billing_address.last_name + "\n" + data.billing_address.address1 + "\n" + data.billing_address.address2 + "\n" + data.billing_address.city + " " + data.billing_address.province_code + " " + data.billing_address.zip + "\n" + data.billing_address.country })

  this.setState({date:data.processed_at})
  this.setState({lineItemsVendor:data.line_items.map((i)=>
    i.vendor
  )})



  this.setState({shippingMethod:shippingMethod})
  this.setState({vendorNames:vendorName})
  this.setState({paymentTerms:paymentTerm})
  this.setState({shippingTerms:shippingTerm})
 

    }



  render() {


const{shippingTerms,paymentTerms,shippingMethod,vendorNames}=this.state
    const {shopifyOrderNumber}=this.state
    const {shipingAddress}=this.state
     const {lineItems}=this.state
     console.log("line items",lineItems)
     const{currency}=this.state
     const{poNumber}=this.state
     const{unitPrice}=this.state
    // const{paymentTerm}=this.state
     const{totalPrice}=this.state
     const{totalTax}=this.state
     const{totalDiscount}=this.state
     const{subTotal}=this.state
     const{billingInformation}=this.state
     const{date}=this.state
     const formattedDate = new Date(date).toLocaleString('en-GB',{
       day: 'numeric',
       month: 'numeric',
       year: 'numeric',
     }


     ).replace(/\//g, '-');
     console.log("date ",formattedDate)
     const{lineItemsVendor}=this.state

     console.log("lenvendor"+lineItemsVendor)
    return (
      <div>
        


        <div className="page-container">
          <div>
            <img src={Header}  height={156} />
          </div>

          <div style={{marginTop:'20px',overflow:'auto'}}>
            <div style={{width:'50%', backgroundColor:'white',float: 'left'}}>
              <div style={{width:'80%',border:'1px solid black' }}>
                <div style={{backgroundColor:'darkblue',color:'white', padding:'4px'}}>Bill-To</div>
                <div style={{backgroundColor:'white',padding:'4px'}}>{billingInformation}</div>
              </div>

              <div style={{marginTop:'20px',width:'80%',border:'1px solid black'}}>

             
                <div style={{backgroundColor:'darkblue',color:'white', padding:'4px'}} >Vendor</div>
                <div style={{backgroundColor: 'white', padding:'4px'}}>{vendorNames}</div>
              </div>
            </div>

            <div style={{width:'50%', backgroundColor:'white', float: 'left'}}>


              <div  style={{textAlign:'right', backgroundColor:'white'}}>
                <div style={{padding:'2px'}}>
                  Date: <span className="top-field">{formattedDate}</span>
                </div>
                <div style={{padding:'2px'}}>
                  PO Number: <span className="top-field">{poNumber}</span>
                </div>
                
                <div style={{padding:'2px'}}>Vendor:
                
               
                  
                    <span className="top-field">{vendorNames}</span>
                  
                    

                 
                   
                </div>
                <div style={{padding:'2px' ,marginTop:'10px'}}>
                  Currency: <span className="top-field">${currency}</span>
                </div>
              </div>



              <div style={{width:'90%', border:'1px solid black', marginTop:'15px',float:'right', position:'relative'}}>
                <div style={{backgroundColor:'darkblue', color:'white',padding:'4px'}}>Ship-To</div>
                <div style={{backgroundColor: 'white', padding:'4px'}}>{shipingAddress}</div>
                {/* <!--<div class="shipping-icon">
                <img src="exclamation.png" style="width:100%">
            </div>--> */}
              </div>
            </div>
          </div>

          <table style={{marginTop:'20px', border:'1px solid black', width:'100%', borderSpacing:'0', font: '10pt sans-serif',  breakInside: 'avoid'}}>
            <tr style={{backgroundColor:'darkblue',color:'white'}}>
              <td style={{width:'25%'}}>Shipping Method</td>
              <td style={{width:'25%'}}>Shipping Terms</td>
              <td style={{width:'25%'}}>Delivery Date</td>
              <td style={{width:'25%'}}>Payment Terms</td>
            </tr>


    <tr>
              <td class="">{shippingMethod}</td>
              <td class="">{shippingTerms}</td>
              <td class="">As Soon As Possible{}</td>
              <td class="">{paymentTerms}</td>
            </tr>
  

           
          </table>

          <table  style={{marginTop:'20px', border:'1px solid black', width:'100%', borderSpacing:'0', font: '10pt sans-serif',  breakInside: 'avoid'}}>
            <thead>
              <tr style={{backgroundColor:'darkblue', color:'white'}}>
              
                <td style={{width:'5%'}}>#</td>
                <td style={{style:'7%'}}>Quantity</td>
                <td colspan="2" style={{width:'64%'}}>Description</td>
                <td style={{width:'12%'}}>Unit Price</td>
                <td style={{width:'12%'}}>Total</td>
              </tr>

              
            </thead>

          {
            lineItems.map((item,index)=>(
                <tr key={index}>
              <td></td>
              <td>{item.quantity}</td>
              <td colspan="2">{item.name}</td>
              <td>{item.price}</td>
              <td>{Math.floor(item.price)}</td>
            </tr>

            ))
          }
         
          {/* <td>{unitPrice}</td>
              <td>{Math.floor(unitPrice)}</td> */}

              

  
          </table>

          <div>
            <div>Image References:</div>
          </div>



          <div style={{breakInside:'avoid'}}>
            <div style={{marginTop:'20px', overflow:'auto'}}>
              <div style={{width:'50%', backgroundColor:'', float:'left'}}>
                <div style={{width:'80%', border:'1px solid black'}}>
                  <div style={{backgroundColor:'darkblue',color:'white',padding:'4px'}}>Order Notes</div>
                  <div  style={{backgroundColor:'white' ,width:'20%',padding:'4px',minHeight:'50px'}}>
                    Order# {shopifyOrderNumber}
                    {}
                  </div>
                </div>
              </div>

              <div style={{width:'50%', backgroundColor:'', float: 'left'}}>
                <div  style={{textAlign:'right', backgroundColor:''}}>
                  <div style={{padding:'2px'}}>
                    Sub-total: <span className="top-field" style={{backgroundColor:'white'}} >${subTotal}</span>
                  </div>
                  {/* <!--<div style="padding:2px">Tax: <span class="top-field">${cookie-tax}</span></div>--> */}
                  Shipping / Handling:  {totalTax}
                  {}
                  {}
                  {}
                  {}
                  <div style={{padding:'2px', marginTop:'10px'}}>
                    Total: <span className="top-field" style={{backgroundColor:'white'}} >${totalPrice}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="tc" style={{marginTop:'20px'}}>
              Signature: <span className="top-field" style={{marginRight:'20%',width:'20%'}} >Test{}</span> Date:{}
              <span className="top-field" style={{width:'20%'}}>{formattedDate}</span>
            </div>

            <div className="tc" style={{marginTop:'10px'}}>GST/HST: 770190890 RT0001</div>
          </div>


        </div>
      </div>
    );
  }
}
export default Template;
